/**
 * Unione dei prezzi listino caricati in memoria.
 *
 * Il caricamento dei prezzi di UN solo prodotto (scheda prodotto, modale
 * valori) non deve cancellare quelli degli altri prodotti già in memoria,
 * altrimenti la lista prodotti del magazzino perde le fasce di prezzo.
 * Senza productId (caricamento completo) la risposta sostituisce tutto.
 */
export function mergeProductPrices<T extends { product_id: string }>(
  existing: T[],
  incoming: T[],
  productId?: string,
): T[] {
  if (!productId) return incoming;
  return [...existing.filter(p => p.product_id !== productId), ...incoming];
}
